export enum QuoteStatus {
  BEING_PREPARED = 'being-prepared',
  CANCELED = 'canceled',
  DRAFT = 'draft',
  EXPIRED = 'expired',
  OUT_FOR_SIGNATURE = 'out-for-signature',
  SIGNED = 'signed',
}
